import React from 'react';
import { cn } from '../../../lib/utils';

interface SegmentedControlProps {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  label?: string;
  disabled?: boolean;
  className?: string;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  value,
  onChange,
  options,
  label,
  disabled = false,
  className,
}) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label className="text-sm font-medium text-text-secondary">{label}</label>
      )}
      <div
        className={cn(
          'flex rounded-lg p-1 bg-surface-container border border-border-subtle',
          'overflow-hidden'
        )}
      >
        {options.map((option, index) => {
          const isActive = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              disabled={disabled}
              className={cn(
                'flex-1 py-2 px-2 md:px-4 text-xs md:text-sm font-medium rounded-md transition-all text-center',
                'focus:outline-none focus:ring-2 focus:ring-accent-primary',
                isActive
                  ? 'bg-accent-primary text-[#1a1a1a] shadow-sm font-semibold'
                  : 'text-text-secondary hover:text-text-primary hover:bg-surface-container-high',
                disabled && 'opacity-50 cursor-not-allowed',
                index === 0 && 'rounded-l-md',
                index === options.length - 1 && 'rounded-r-md'
              )}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SegmentedControl;
